/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import * as CommonHttp from "./commonHttp"
import { getPegadaBaseUrl } from "./baseUrl"

let baseUrl = getPegadaBaseUrl()

let getTenantListUrl = `${baseUrl}/v1/tenants/list`
let updateTenantUrl = `${baseUrl}/v1/tenants/update`
let deleteTenantUrl = `${baseUrl}/v1/tenants/delete`
let createTenantUrl = `${baseUrl}/v1/tenants/regist`

export async function getTenantList(session) {
    try {
        let token = (typeof session === 'string' || session instanceof String) ? session : await CommonHttp.getJwtToken(session)
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }

        return await CommonHttp.send(getTenantListUrl, CommonHttp.GET, headers)
    } catch (e) {
        throw e
    }
}

export async function updateTenant(session, body) {
    try {
        let token = (typeof session === 'string' || session instanceof String) ? session : await CommonHttp.getJwtToken(session)
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }

        return await CommonHttp.send(updateTenantUrl, CommonHttp.POST, headers, body)
    } catch (e) {
        throw e
    }
}

export async function deleteTenant(session, body) {
    try {
        let token = (typeof session === 'string' || session instanceof String) ? session : await CommonHttp.getJwtToken(session)
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }

        return await CommonHttp.send(deleteTenantUrl, CommonHttp.POST, headers, body)
    } catch (e) {
        throw e
    }
}

export async function createTenant(session, body) {
    try {
        let token = (typeof session === 'string' || session instanceof String) ? session : await CommonHttp.getJwtToken(session)
        let headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }

        return await CommonHttp.send(createTenantUrl, CommonHttp.POST, headers, body)
    } catch (e) {
        throw e
    }
}